import React from "react";
import {
    Box,
    Typography,
    Grid,
    Paper,
    CircularProgress,
} from "@mui/material";
import StepContainer from "./StepContainer";
import classes from "./styles";
import Stepper from "./Stepper";
import { useQuery } from "@tanstack/react-query";
import groupBy from "../../pages/utils/groupBy";
import { StatusAuditAPI } from "../../services/StatusAuditAPI";

const StepperStatus = ({ complaintId, createdAt }) => {

    const transformData = ({ data }) => {
        const transformedData = structuredClone(data);

        transformedData.unshift({
            date: createdAt,
            newStatus: "Novo",
            typeNewStatus: "Abertura",
            description: "Nova ocorrência aberta"
        });

        const grouped = groupBy(transformedData, "typeNewStatus");

        return grouped;
    }

    const {
        data: status = {},
        isPending,
    } = useQuery({
        queryKey: ["status", complaintId],
        queryFn: () => StatusAuditAPI.get({ complaint_id: complaintId }),
        select: transformData,
        enabled: !!complaintId,
    });

    // Deriva as etapas direto do status para evitar estado defasado: ao trocar
    // de ocorrência o `status` volta a {} enquanto recarrega, e manter `steps`
    // em estado separado mostrava as etapas antigas com conteúdo vazio
    // ("Etapa não iniciada") por um instante.
    const steps = Object.keys(status);

    return (
        <Paper style={classes.paper} elevation={1}>
            <Typography variant="h6" textAlign="center" style={classes.textTitle}>
                Status da Solicitação
            </Typography>
            {isPending ? (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: 120,
                    }}
                >
                    <CircularProgress />
                </Box>
            ) : (
                <>
                    <Stepper steps={steps} />
                    <Grid
                        container
                        spacing={2}
                        justifyContent="center"
                        alignItems="flex-start"
                        sx={{ marginTop: 1 }}
                    >
                        {
                            steps.map((step, index) => (
                                <Grid item xs={12} sm={12} md={steps.length === 1 ? 4 : 12 / steps.length} key={index}>
                                    <Box textAlign="center">
                                        <StepContainer
                                            steps={status[step]}
                                        />
                                    </Box>
                                </Grid>
                            ))
                        }
                    </Grid>
                </>
            )}
        </Paper>
    );
};

export default StepperStatus;
